import React, { useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { FaCogs, FaChartLine, FaBoxes, FaMicrochip, FaProjectDiagram, FaBolt } from "react-icons/fa";
import heroBg from "../../assets/trace.png"; // replace with your hero image
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";
import "./InjectionMould.css";

function InjectionMould() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="injection-page">
      <Header /> {/* Header untouched */}

      <div className="injection-content"> {/* Wrapper to prevent overriding header/footer */}

        {/* Hero Section */}
        <section
          className="injection-hero"
          style={{ backgroundImage: `url(${heroBg})` }}
        >
          <div className="hero-overlay"></div>
          <h1 className="hero-title">
            Streamlining Injection Molding & Assembly with MES
          </h1>
        </section>

        {/* Hero Content Section */}
        <section className="injection-hero-content">
           <h2>  Injection Molding & Assembly with MES</h2>
          <p>
            Our Manufacturing Execution System (MES) optimizes injection molding
            and assembly processes. With real-time tracking and automated data
            collection, you can enhance quality, efficiency, and decision-making.
          </p>
          {/* <button className="cta-btn">Discover More</button> */}
        </section>

        {/* How It Works Section
        <section className="how-it-works">
          <h2>How It Works</h2>
          <div className="how-info">
            <div className="how-step">
              <div className="step-number">1</div>
              <FaCogs className="step-icon" />
              <div className="step-content">
                <h4>Process Automation</h4>
                <p>Automate repetitive tasks and optimize workflows in real time.</p>
              </div>
            </div>
            <div className="how-step">
              <div className="step-number">2</div>
              <FaProjectDiagram className="step-icon" />
              <div className="step-content">
                <h4>Integrated Tracking</h4>
                <p>Track injection, assembly, and inspection processes seamlessly.</p>
              </div>
            </div>
            <div className="how-step">
              <div className="step-number">3</div>
              <FaBolt className="step-icon" />
              <div className="step-content">
                <h4>Fast Analytics</h4>
                <p>Access actionable insights instantly to improve operations.</p>
              </div>
            </div>
          </div>
        </section> */}

        {/* Highlights Section */}
        <section className="injection-highlights">
          <div className="highlight-card">
            <FaCogs className="icon" />
            <h3>Enhance Quality Control</h3>
            <p>Monitor product quality and detect defects throughout production.</p>
          </div>
          <div className="highlight-card">
            <FaChartLine className="icon" />
            <h3>Improve Efficiency</h3>
            <p>Optimize workflows, reduce downtime, and increase productivity.</p>
          </div>
          <div className="highlight-card">
            <FaBoxes className="icon" />
            <h3>Make Data-Driven Decisions</h3>
            <p>Access real-time data and analytics to inform smart business decisions.</p>
          </div>
        </section>

        {/* Key Features Section */}
        <section className="injection-features">
          <h2>Key Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <FaCogs className="feature-icon" />
              <h4>Process Tracking</h4>
              <p>Monitor injection molding, annealing, assembly, and final inspection.</p>
            </div>
            <div className="feature-card">
              <FaChartLine className="feature-icon" />
              <h4>Quality Control</h4>
              <p>Track product quality and detect defects early in the process.</p>
            </div>
            <div className="feature-card">
              <FaBoxes className="feature-icon" />
              <h4>Inventory Management</h4>
              <p>Manage raw materials and finished goods efficiently.</p>
            </div>
            <div className="feature-card">
              <FaMicrochip className="feature-icon" />
              <h4>Real-Time Analytics</h4>
              <p>Empower your team with actionable insights instantly.</p>
            </div>
          </div>
        </section>

        {/* Impact Section */}
        <section className="injection-impact">
          <h2>Transform Your Injection Molding Process</h2>
          <p>
            By implementing our MES, you can streamline your injection molding and
            assembly processes, improve product quality, and boost efficiency
            across all operations.
          </p>
        </section>

      </div> {/* end of injection-content */}

      <Footer /> {/* Footer untouched */}
      <ERPChatbot />
    </div>
  );
}

export default InjectionMould;
